class FixedBar extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['product-form']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.productFormVisible = false
    this.productForm = this.externalEls['product-form'].element

    this.handleEditClick = this.handleEditClick.bind(this)
    this.handleBackInStockClick = this.handleBackInStockClick.bind(this)
    this.updateFixedVariant = this.updateFixedVariant.bind(this)
    this.updateAddToCartButton = this.updateAddToCartButton.bind(this)

    this.listeners.add(this.productForm, 'change', this.updateFixedVariant)

    if (this.externalEls.productAddToCart?.exists) {
      this.listeners.add(this.externalEls.productAddToCart.element, 'change', this.updateAddToCartButton)
    }

    if (this.els?.editButton?.exists) {
      this.listeners.add(this.els.editButton.element, 'click', this.handleEditClick)
    }

    if (this.els?.backInStockButton?.exists) {
      this.listeners.add(this.els.backInStockButton.element, 'click', this.handleBackInStockClick)
    }

    if (this.els?.select?.exists) {
      this.listeners.add(this.els.select.element, 'change', this.clickProductForm.bind(this))
    }

    this.checkProductFormPosition = this.checkProductFormPosition.bind(this)
    this.updateSelect = this.updateSelect.bind(this)

    this.listeners.add(window, 'scroll', window.BAO.Utils.debounce(this.checkProductFormPosition, 100), { passive: true })
    this.listeners.add(document, 'variantChange', this.updateSelect)
    this.listeners.add(window, 'resize', this.checkProductFormPosition)
    this.listeners.add(window, 'load', this.checkProductFormPosition)

    this.setupObservers()
  }

  setupObservers () {
    const cartAddButton = this.externalEls.productAddToCart.element

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.attributeName === 'disabled') {
          this.updateAddToCartButton()
        }
      }
    })

    observer.observe(cartAddButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    })
  }

  checkProductFormPosition () {
    const rect = this.productForm.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const stickyNavHeight = 80
    const viewPortHeight = viewportHeight - stickyNavHeight

    // Check if product form is visible in viewport
    const productFormIsVisible =
      rect.top >= -rect.height &&
      rect.top < viewPortHeight &&
      rect.bottom > stickyNavHeight &&
      rect.bottom <= viewportHeight

    const prodRecsEl = document.querySelector('.product-recommendations')
    if (!prodRecsEl) {
      this.isHidden = !productFormIsVisible
      return
    }

    // Show the fixed bar when:
    // 1. Product form is NOT visible AND
    // 2. Product form is below the current screen
    const shouldShowFixedBar = !productFormIsVisible && rect.top < 0
    this.isHidden = !shouldShowFixedBar
  }

  updateSelect () {
    const productVariants = document.querySelectorAll('[data-variant-radios-el="option-choice"]')

    if (!productVariants || productVariants.length === 0) {
      console.error('No product variants found')
      return
    }

    for (const variant of productVariants) {
      if (variant.checked) {
        this.selectedVariant = variant
      }
    }

    if (!this.selectedVariant) {
      console.error('No selected variant found')
      return
    }

    this.els.select.element.value = this.selectedVariant.value

    const chosenVariantImage = this.selectedVariant.closest('div').querySelector('[data-variant-image]')
    if (chosenVariantImage) {
      this.els.image.element.innerHTML = chosenVariantImage.outerHTML
    } else {
      console.error('No image found for selected variant')
    }

    for (const title of this.els.title.elements) {
      title.innerHTML = this.selectedVariant.value
    }
  }

  clickProductForm () {
    const options = document.querySelectorAll(".select__select[name='options[Size]'] option")
    const newSelectOption = document.querySelector(`.select__select[name='options[Size]'] [value='${this.els.select.element.value}']`)

    if (newSelectOption) {
      for (const option of options) {
        option.removeAttribute('selected')
      }

      newSelectOption.setAttribute('selected', 'selected')
    } else {
      console.error('No variant found for the selected title:', this.els.select.element.value)
    }
  }

  get isHidden () {
    return this._isHidden
  }

  set isHidden (isHidden) {
    this._isHidden = isHidden
    this.setAttribute('aria-hidden', String(isHidden))
  }

  handleEditClick () {
    this.productForm.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  handleBackInStockClick () {
    document.querySelector('.klaviyo-bis-trigger').click()
  }

  updateFixedVariant () {
    this.els.fixedBarVariant.element.textContent = this.externalEls.variantSelect.element.value
  }

  updateAddToCartButton () {
    const isDisabled = this.externalEls.productAddToCart.element.disabled === true
    const addToCartEl = this.els.addToCart?.element

    this.els.backInStockButton?.element?.setAttribute('aria-hidden', (!isDisabled).toString())
    addToCartEl?.setAttribute('aria-hidden', isDisabled.toString())
    if (addToCartEl) addToCartEl.disabled = isDisabled
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
